import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import FormItem from 'app/components/Form/FormItem';
import List from 'app/components/List';
import { Title } from 'app/components/Typography/Title';
import Button from 'app/components/Button';
import ProductItem from '../../ProductItem';
import { IProduct } from 'app/types/interfaces/Product';
import { FormInstance, Row } from 'antd';
import Tag from 'app/components/Tag';
import { useWatch } from 'antd/lib/form/Form';

const LinkageProduct = ({
  onSelectProduct,
  onRemoveProduct,
  form
}: {
  onSelectProduct: () => void;
  onRemoveProduct: (item: IProduct) => void;
  form: FormInstance;
}) => {
  const products = useWatch('products', form);

  return (
    <div>
      <Row justify="space-between">
        <Title level={4}>Build Product Linkage</Title>
        <Tag color={products?.length > 0 ? '#005EFF' : '#F0F5FF'}>
          <div style={{ color: products?.length > 0 ? '#FFF' : '#4E5A71' }}>
            Selected {products?.length} product{products?.length > 1 && 's'}
          </div>
        </Tag>
      </Row>
      <FormItem name="products" valuePropName="dataSource">
        <List
          height="400px"
          renderItem={(item, index) => {
            return (
              <ProductItem
                buttonProps={{
                  onClick: () => {
                    onRemoveProduct(item);
                    // setValue(value.concat(item));
                  }
                }}
                product={item}
                order={index}
              ></ProductItem>
            );
          }}
        ></List>
      </FormItem>
      <Button onClick={onSelectProduct} type="primary" ghost borderRadius={2}>
        <PlusOutlined />
        Existing Product
      </Button>
    </div>
  );
};

export default LinkageProduct;
